import request from '@/utils/request'

// 查询业务积分分类列表
export function listCategory(query) {
  return request({
    url: '/point/category/list',
    method: 'get',
    params: query
  })
}

// 批量分配业务积分分类
export function batchAssignCategory(data) {
  return request({
    url: '/point/userCategory/assign',
    method: 'post',
    data: data
  })
}
